/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Open_Princes_HintInputs */



/**
* | output |
* | --- |
* | "Princes of the league's country can add their tournaments without being league organizers." |
*
* @param {League_Open_Princes_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_open_princes_hint = /** @type {((inputs?: League_Open_Princes_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Open_Princes_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les Princes du pays de la ligue peuvent ajouter leurs tournois sans être organisateurs de la ligue.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los Princes del país de la liga pueden añadir sus torneos sin ser organizadores de la liga.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os Princes do país da liga podem adicionar seus torneios sem serem organizadores da liga.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I Princes del paese del campionato possono aggiungere i loro tornei senza esserne organizzatori.")
	return /** @type {LocalizedString} */ ("Princes of the league's country can add their tournaments without being league organizers.")
});